/**
 * Utility class that evaluates dynamic filters.
 */
export default function evaluate(filter, value) {

  return Object.keys(filter).every((key) => {

    const filterValue = filter[key];

    switch (key) {
      case 'and':
        // An AND has sub-filters which must all return 'true' for the AND to return 'true'.
        return filterValue.every(subFilter => evaluate(subFilter, value));

      case 'or':
        // An OR has sub-filters where at least one must return 'true' for the OR to return
        // 'true'.
        return filterValue.some(subFilter => evaluate(subFilter, value));

      case 'equals':
        return value === filterValue;

      case 'gt':
        return value > filterValue;

      case 'gte':
        return value >= filterValue;

      case 'lt':
        return value < filterValue;

      case 'lte':
        return value <= filterValue;

      case 'rangeInclusive':
        return value >= filterValue.low && value <= filterValue.high;

      case 'rangeExclusive':
        return value > filterValue.low && value < filterValue.high;

      default:
        return true;
    }
  }, this);

}



// WEBPACK FOOTER //
// ./src/app/utils/simple-filter-evaluator.js